<template>
    <div id="listRate">
        <div :class="`loader${loaderClass}`" v-show="loading">

        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                    <div class="page-name">Email List

                    </div>
                    <!--page content-->
                    <div class="admin-page-content customer-detail">
                        <section class="internal-container">
                            <div class="container">
                                <vue-good-table
                                        mode="remote"
                                        @on-page-change="onPageChange"
                                        @on-sort-change="onSortChange"
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange"
                                        :totalRows="totalRecords"
                                        title="Emails"
                                        :columns="columns"
                                        :rows="rows"
                                        :paginate="true"

                                        :paginationOptions="{
                                            enabled: true,
                                            position: 'both',
                                            perPage: perPage,
                                            dropdownAllowAll: false,
                                        }"
                                        :sort-options="{
                                            enabled: true,
                                        }"
                                    >
                                    <!-- <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'" class='btn-center-vvg'>
                                                <template v-if="permission.name == 'add_user'" v-for="(permission, index) in permissions">
                                                    <router-link title="Edit User" v-bind:key="'action' + index" class="glyphicon glyphicon-edit" v-bind:to="{name: 'UserEdit',params:{id:props.row.id}}"></router-link>
                                                </template>
                                                <template v-if="props.row.is_active == 'Inactive'">
                                                    <a href="#" v-on:click.prevent="changeStatus(props.row.id)">
                                                        <font color="green"><span title="Active User" class="glyphicon glyphicon-ok-circle"></span></font>
                                                    </a>
                                                </template>
                                                <template v-else>
                                                    <a href="#" v-on:click.prevent="changeStatus(props.row.id)">
                                                        <font color="red"><span title="Inactive User" class="glyphicon glyphicon-ban-circle"></span> </font>
                                                    </a>
                                                </template>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template> -->
                                </vue-good-table>
                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>

<script>

    import Vue from 'vue';


    import {commonMixins} from '../mixins/commonMixins';

    import EventBus from "././event-bus";




    export default {
        name: "sentemail",
        mixins:[commonMixins],
        data: () => ({
             permissions: [],
            cantAccessPage: "",
            firstLoad : 0,
            columns: [
                {
                    label: 'Sent To',
                    field: 'sent_to',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Sent To", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Email',
                    field: 'email',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Email", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    html:true
                },
                {
                    label: 'Sent By',
                    field: 'created_by',
                    html: false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Sent By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Type',
                    field: 'type',
                    html: false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status',
                    field: 'status',
                    html: false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Status", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Queued', 'Sent','Opened','Failed'], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Date',
                    field: 'updated_at',
                    html: false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "M / d / y", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

                // {
                //     label: 'Actions',
                //     field: 'action',
                //     sortable: false,
                // },

            ],
            rows: [],
            totalRecords: 0,
            serverParams: {
                columnFilters: {
                },
                sort: {
                    field: 'updated_at',
                    type: 'desc',
                },
                page: 1,
                perPage: 50
            },
            loading:false,
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_user') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            }
        },
        mounted: function () {

            var self = this;

            self.getPermissions();

        },
        methods: {

            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadEmailReport();
            },
            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadEmailReport();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (this.firstLoad == 1 || filters.sent_to || filters.email || filters.type || filters.status || filters.updated_at || filters.created_by ) {
                    this.loadEmailReport();
                }
            },
            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadEmailReport();
            },

            loadEmailReport(){

                var self = this;
                self.loading = true;
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/sent/emails",
                    type: "GET",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: self.serverParams.columnFilters,
                        sort: self.serverParams.sort,
                    },
                    success: function (data) {
                        self.loading = false;
                        //console.log(data.content[0]["id"]);
                        if (data.status == "success") {
                            self.rows = data.content.row;

                            // self.perPage = data.content.perPage;
                            // if (data.content.totalRecords == 0){
                            //     self.rows = 0;
                            // }
                            self.totalRecords = data.content.totalRecords;

                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server cannot be reached";
                        } else {

                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('tkn');

                                self.$router.push("/");
                            }

                            self.error = jqXHR.responseJSON.message;

                        }

                    }
                });
            }
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/SentEmail.vue